import MainSection from '@/components/common/MainSection/MainSection';

const LiSettingsId = () => {
  return <MainSection isEditMode origin="lineItem" />;
};

export default LiSettingsId;
